// Only the bounded pin viewport is compared on the rendering thread. The global
// dot diff comes straight from the worker, with stable catalog feature IDs.
const previous=new WeakMap(),epochs=new WeakMap();
export function clearSiteData(source){epochs.set(source,(epochs.get(source)||0)+1);previous.delete(source);return source.setData({type:'FeatureCollection',features:[]});}
export async function setSiteData(source,features){
  const epoch=epochs.get(source)||0,commit=next=>{if((epochs.get(source)||0)===epoch)previous.set(source,next);};
  const old=previous.get(source),next=new Map(features.map(f=>[f.id,JSON.stringify(f)]));
  if(!old){await source.setData({type:'FeatureCollection',features});commit(next);return;}
  const diff={remove:[...old.keys()].filter(id=>!next.has(id)),add:[],update:[]};
  for(const f of features){
    if(!old.has(f.id))diff.add.push(f);
    // MapLibre's worker ignores replacement properties with removeAllProperties.
    // Remove only vanished keys so the native tiles retain the new sprite tags.
    else if(old.get(f.id)!==next.get(f.id))diff.update.push({id:f.id,newGeometry:f.geometry,
      removeProperties:Object.keys(JSON.parse(old.get(f.id)).properties).filter(key=>!(key in f.properties)),
      addOrUpdateProperties:Object.entries(f.properties).map(([key,value])=>({key,value}))});
  }
  if(diff.remove.length||diff.add.length||diff.update.length)await source.updateData(diff);
  commit(next);
}
export function applySiteDiff(source,diff){if(diff.add.length||diff.remove.length||diff.update.length)return source.updateData(diff);}
